import axios from "axios";
import { authDeviceHeader } from "../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;

class MKTDeviceService {
  async getPPTPUserList(filter = "") {
    return await axios
      .get(API_URL + `mikrotik/device` + filter, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async addPPTPUser(data) {
    return await axios
      .post(API_URL + `mikrotik/device`, data, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async getPPTPUserDetails(userID) {
    return await axios
      .get(API_URL + `mikrotik/device?mikrotik_uuid=${userID}`, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async updatePPTPUser(mikrotik_uuid, data) {
    return await axios
      .patch(API_URL + `mikrotik/device/${mikrotik_uuid}`, data, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async deletePPTPUser(id) {
    return await axios
      .delete(API_URL + `mikrotik/device/${id}`, {
        headers: authDeviceHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new MKTDeviceService();
